import { render } from "./LoadingAnimation.vue?vue&type=template&id=cc3a65e4&ts=true"
import script from "./LoadingAnimation.vue?vue&type=script&lang=ts"
export * from "./LoadingAnimation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__